module.exports = __webpack_public_path__ + "img/daohang.c6ffe7c9.png";